export const timeline = [
    {
        id: 1,
        title: 'Web Developer Freelancer',
        subtitle: '',
        content: '<p>Started my web developer journey doing some simple freelance projects.</p>',
        date: '2011 - Present',
    },
    {
        id: 2,
        title: 'Full-Stack Web Developer',
        subtitle: '',
        content:
            '<p>Started working as a full time web developer for the company <a class="has-text-info" href="https://www.actualsales.com/" target="_blank" rel="noreferrer">ActualSales</a>. Integrated in a bussiness unit called "Made For The Cloud".</p>',
        date: 'Jan 2013 - Aug 2014',
    },
    {
        id: 3,
        title: 'Full-Stack Web Developer',
        subtitle: '',
        content:
            '<p>Went to <a class="has-text-info" href="https://www.actualsales.com/" target="_blank" rel="noreferrer">ActualSales</a> in São Paulo, Brazil to work on another bussiness unit of the company - Research & Design.</p>',
        date: 'Aug 2014 - Jan 2015',
    },
    {
        id: 4,
        title: 'Full-Stack Web Developer',
        subtitle: '',
        content:
            '<p>Back to Portugal and started working for the company <a class="has-text-info" href="http://www.inboxagency.com/" target="_blank" rel="noreferrer">INBOX Agency</a>.</p><p>Responsible for all the current development and maintenance - Front-End, Back-End and all his services - on one of the biggest websites (according to NetScope rank) in Portugal - <a class="has-text-info" href="https://www.noticiasaominuto.com/" target="_blank" rel="noreferrer">Notícias ao Minuto</a> and also for his "brother" - <a class="has-text-info" href="https://www.noticiasaominuto.com.br/" target="_blank" rel="noreferrer">Notícias ao Minuto Brasil</a>.</p><p>Doing some other internal projects as well.</p>',
        date: 'Apr 2015 - Dec 2017',
    },
    {
        id: 5,
        title: 'Software Engineer - UI',
        subtitle: '',
        content:
            "<p>Full time as a frontend developer @ <a class='has-text-info' href='https://www.farfetch.com/' target='_blank' rel='noreferrer'>Farfetch</a>.</p><p>Working mainly in micro-services using React, Redux and SASS. Time to time have to work on pure javascript only.</p><p>Due to a <abbr title='Non-disclosure agreement'>NDA</abbr>, I cannot share the work I've done.</p>",
        date: 'Jan 2018 - Oct 2018',
    },
    {
        id: 6,
        title: 'Senior Frontend Developer',
        subtitle: '',
        content:
            "<p>Full time as a frontend developer @ <a class='has-text-info' href='https://habit.io/' target='_blank' rel='noreferrer'>Habit Analytics</a>.</p><p>Responsible to create from scratch a very ambitious <abbr title='Single Page Application'>SPA</abbr>. Built using React(<abbr title='Create React App'>CRA</abbr>); Redux; SASS. It has dozens of routes with a ton of features to create a White Label App, manage builds, users, team members, etc...</p><p>Due to a <abbr title='Non-disclosure agreement'>NDA</abbr>, I cannot share the work I've done.</p>",
        date: 'Nov 2018 - Present',
    },
];
